import { Button, Modal, Result, Typography } from "antd";

import styles from "./ApprovalManagement.module.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  message: string;
}

/**
 * "Success!" confirmation for Approval Management saves.
 *
 * Distinct from the Work Order SentSuccessModal: the title sits above the
 * check mark here rather than below it, per the design.
 */
export const SuccessModal = ({ open, onClose, message }: Props) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    centered
    width={380}
    maskClosable={false}
    className={styles.successModal}
  >
    <Typography.Title
      level={2}
      className={styles.successTitle}
    >
      Success!
    </Typography.Title>
    <Result
      status="success"
      subTitle={message}
      extra={
        <Button
          type="primary"
          onClick={onClose}
        >
          Ok
        </Button>
      }
    />
  </Modal>
);
